import React, { Component } from "react";
import Login from "../components/Login";
import { withRouter } from "react-router-dom";
import { languages } from "../constants/languages";

class LoginContainer extends Component {
  state = {
    email: "",
    password: "",
    errorMessage: "",
  };

  handleEmailChange = (event) => {
    this.setState({ email: event.target.value });
  };

  handlePasswordChange = (event) => {
    this.setState({ password: event.target.value });
  };

  handleLogin = (event) => {
    event.preventDefault();
    window.firebase
      .auth()
      .signInWithEmailAndPassword(this.state.email, this.state.password)
      .then(() => {
        if (this.props.psdCode) {
          let location = "/prosoccerdata/" + this.props.psdCode;
          this.props.history.push(location);
        }
      })
      .catch(
        function (error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          if (errorCode === "auth/invalid-email") {
            errorMessage = languages.login.invalidEmail;
          } else if (errorCode === "auth/user-not-found") {
            errorMessage = languages.login.userNotFound;
          } else if (errorCode === "auth/wrong-password") {
            errorMessage = languages.login.wrongPassword;
          }
          this.setState({ errorMessage: errorMessage });
        }.bind(this)
      );
  };

  generateProps = () => ({
    ...this.state,
    handleEmailChange: this.handleEmailChange,
    handlePasswordChange: this.handlePasswordChange,
    handleLogin: this.handleLogin,
  });

  render() {
    const props = this.generateProps();
    return <Login {...props} />;
  }
}

export default withRouter(LoginContainer);
